<template>
  <div>
    <div v-if='showSpinner' class='loader-wrapper'>
      <div class='loader'></div>
    </div>
    <deal-information
      ref='dealInfo'
      v-bind:type="'acis'"
      :shownTypes="['ACIS']"
      v-bind:inputError='inputError'
      :validDeal.sync='validDeal'
      :report1='report1'
      @dealNameChange='dealName = $event'
      @bondNameChange='bondName = $event'
      @settlementDateChange='onSettlementDateChange'
      @cprChange='cpr = $event'
      @cdrChange='cdr = $event'
      @lossSeverityChange='lossSeverity = $event'
      @delinquencyChange='delinquency = $event'
      @liborChange='libor = $event'
      @hpiChange='hpi = $event'
      @NationalUnemploymentForecastChange='NationalUnemploymentForecast = $event'
      @hpaChange='hpa = $event'
      @2YrTsyChange='twoYrTsy = $event'
      @10YrTsyChange='tenYrTsy = $event'
      @tuneCprChange='tuneCpr = $event'
      @tuneCdrChange='tuneCdr = $event'
      @tuneSeverityChange='tuneSeverity = $event'
      @mtg15Change='mtg15Yr = $event'
      @mtg30Change='mtg30Yr = $event'
      @show-spinner='showSpinner = true'
      @hide-spinner='showSpinner = false'
      @cancellationChange='cancellation = !cancellation'
      @cancellationDateChange='cancellationDate = $event'
      @scenarioChange='scenario = $event'
    />
    <acis
      v-if='validDeal'
      v-bind:dealName='dealName'
      v-bind:bondName='bondName'
      v-bind:settlementDate='settlementDate'
      v-bind:cpr='cpr'
      v-bind:cdr='cdr'
      v-bind:lossSeverity='lossSeverity'
      v-bind:delinquency='delinquency'
      v-bind:libor='libor'
      :hpi='hpi'
      :NationalUnemploymentForecast='NationalUnemploymentForecast'
      :hpa='hpa'
      :twoYrTsy='twoYrTsy'
      :tenYrTsy='tenYrTsy'
      :tuneCpr='tuneCpr'
      :tuneCdr='tuneCdr'
      :tuneSeverity='tuneSeverity'
      :mtg15Yr='mtg15Yr'
      :mtg30Yr='mtg30Yr'
      :cancel='cancellation'
      :cancellationDate='cancellationDate'
      :selectedScenario='scenario'
      @inputError='inputError = $event'
      @show-spinner='this.onShowSpinner'
      @hide-spinner='showSpinner = false'
    />
  </div>
</template>

<script>
import DealInformation from '../dealInformation/';
import Acis            from './Acis';
import ReportsNames    from '@/constants/reportsNames';
import moment          from 'moment';

export default {
  data() {
    return {
      dealName: '',
      bondName: this.$store.getters.bondName,
      settlementDate: {},
      cpr: [0],
      cdr: [0],
      lossSeverity: [0],
      delinquency: [0],
      libor: [],
      hpi: [],
      NationalUnemploymentForecast: [],
      hpa: [],
      twoYrTsy: '',
      tenYrTsy: '',
      tuneCpr: [1],
      tuneCdr: [1],
      tuneSeverity: [1],
      mtg15Yr: [0],
      mtg30Yr: [0],
      inputError: '',
      showSpinner: false,
      validDeal: false,
      cancellation: false,
      cancellationDate: '',
      scenario: null,
      ReportsNames
    };
  },
  computed: {
    report1() {
      return {
        pReportName: ReportsNames.Historical.ACIS,
        pReportParams: [
          {
            'DbName': 'deal',
            'Value': this.$route.query.dealName
          }
        ],
        flagShowOwnRunButton: false,
        pLabelRunButton: `Run ${ReportsNames.Historical.ACIS} Report`
        //triggerRunReport:     false, // SHOULD BE DEFINED IN CHILD DATA
      };
    }
  },
  created() {
    let queryBondName = this.$route.query.bondName;
    if (queryBondName) {
      this.bondName = queryBondName;
    }
  },
  methods: {
    onSettlementDateChange(settlementDate) {
      // TODO: Change the ACIS component to properly handle the settlement date
      // Specifically for re-routing it to the ACIS
      this.settlementDate = moment(settlementDate).format('YYYYMMDD');
    },
    onShowSpinner() {
      this.showSpinner = true;
      this.$refs.dealInfo.setCookies(this.$refs.dealInfo);
    }
  },
  components: {
    DealInformation,
    Acis
  }
};
</script>
